import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { VetSchedulePlannerLandingComponent } from './landing/landing.component'
import { VetSchedulePlannerRoutingModule } from './vet-schedule-planner-routing.module'
import { DropdownModule } from 'primeng/dropdown'
import { ButtonModule } from 'primeng/button'
import { TableModule } from 'primeng/table'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { TooltipModule } from 'primeng/tooltip'
import { SharedModule } from '../shared/shared.module'
import { TableCellComponent } from './table-cell/table-cell.component'
import { DialogModule } from 'primeng/dialog'
import { DayDialogComponent } from './day-dialog/day-dialog.component'
import { DatePickerModule } from 'primeng/datepicker'
import { BlockUIModule } from 'primeng/blockui'
import { PanelModule } from 'primeng/panel'
import { SelectModule } from 'primeng/select'
import { AddDoctorDialogComponent } from './add-doctor-dialog/add-doctor-dialog.component'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { DoctorInfoDialogComponent } from './doctor-info-dialog/doctor-info-dialog.component'
import { ListboxModule } from 'primeng/listbox'
import { CdkDragPlaceholder } from '@angular/cdk/drag-drop'
import { InactiveDoctorListDialogComponent } from './inactive-doctor-list-dialog/inactive-doctor-list-dialog.component'
import { VspTimePipe } from './vsp-time.pipe'
import { MenuModule } from 'primeng/menu'
import { ConfirmDialogModule } from 'primeng/confirmdialog'

@NgModule({
   declarations: [
      VetSchedulePlannerLandingComponent,
      TableCellComponent,
      DayDialogComponent,
      AddDoctorDialogComponent,
      DoctorInfoDialogComponent,
      InactiveDoctorListDialogComponent,
      VspTimePipe,
   ],
   imports: [
      CommonModule,
      FormsModule,
      VetSchedulePlannerRoutingModule,
      DropdownModule,
      ButtonModule,
      TableModule,
      BreadcrumbModule,
      TooltipModule,
      SharedModule,
      DialogModule,
      DatePickerModule,
      BlockUIModule,
      PanelModule,
      SelectModule,
      AutoCompleteModule,
      ListboxModule,
      CdkDragPlaceholder,
      MenuModule,
      ConfirmDialogModule,
   ],
})
export class VetSchedulePlannerModule {}
